import { render, staticRenderFns } from "./ProjectSummaryCredits.vue?vue&type=template&id=10fc627e&"
import script from "./ProjectSummaryCredits.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports